var $ffb2f77741c566ee$exports = {};
$ffb2f77741c566ee$exports = {
  "collapse": "Sutraukti",
  "expand": "I\u0161skleisti"
};
export { $ffb2f77741c566ee$exports as default };